import { apiProvider } from "./utilities/provider";
import { Onboarding } from "../../models/grower";

export const onboardingsApi = {
  patch: (onboarding: Onboarding): Promise<void> =>
    apiProvider.patch("onboardings", undefined, {
      data: onboarding,
    }),
};
